import { Controller } from "@hotwired/stimulus";
import Backup from "./backup";
import Uploader from "./uploader";

export default class extends Controller {
  static values = {
    alerts: Object,
    consultationId: Number,
  }

  disconnect() {
    this.isCancelled = this.mediaRecorder?.state !== "inactive";
    if (this.stream) {
      this.stream.getTracks().forEach((track) => track.stop());
    }
  }

  async prepare() {
    try {
      this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      this.backup = new Backup(this.consultationIdValue);
    } catch (error) {
      switch (error.name) {
        case "NotAllowedError":
          alert(this.alertsValue.not_allowed_error);
          break;
        case "NotFoundError":
          alert(this.alertsValue.not_found_error);
          break;
        case "NotReadableError":
          alert(this.alertsValue.not_readable_error);
          break;
        case "OverconstrainedError":
          alert(this.alertsValue.overconstrained_error);
          break;
        case "SecurityError":
          alert(this.alertsValue.security_error);
          break;
        default:
          alert(this.alertsValue.unknown_error);
      }
      return "error";
    }
  }

  start() {
    const isChromeNavigator = /Chrome/.test(navigator.userAgent);
    const isSupportedFormat = MediaRecorder.isTypeSupported("audio/mp4");
    const mimeType = isChromeNavigator && isSupportedFormat ? "audio/mp4" : undefined;
    this.mediaRecorder = new MediaRecorder(this.stream, { mimeType });

    this.mediaRecorder.start(1000);

    this.audioChunks = [];

    this.mediaRecorder.ondataavailable = (event) => {
      this.audioChunks.push(event.data);
    };

    this.backupInterval = setInterval(async () => {
      this.backupBlob = new Blob(this.audioChunks);
      try {
        await this.backup.injectBlob(this.backupBlob);
      } catch (error) {
        console.log(error);
      }
    }, 5000);

    this.mediaRecorder.onstop = async () => {
      clearInterval(this.backupInterval);
      if (this.isCancelled) return;

      const audioBlob = new Blob(this.audioChunks);
      const audioFile = new File([audioBlob], "record");

      await this.backup.injectBlob(audioBlob);

      const uploader = new Uploader(
        audioFile,
        this.element,
        this.consultationIdValue,
        this.backup,
      );

      uploader.uploadFile(audioFile);
    };
  }

  resume() {
    this.mediaRecorder.resume();
  }

  pause() {
    this.mediaRecorder.pause();
  }

  stop() {
    this.mediaRecorder.stop();
  }
}
